<template>
    <div>
        <b-form-group
            description="User can choose file from library"
            label="Choose from library"
            label-for="choose_from_library"
            :label-cols="4"
            :horizontal="true">
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.file.chooseFromLibrary" @change="(e) => handleChange('libraryOptions', e)" v-if="mediaIntegrationActive"/>
            <span v-else>To use this funcionality you need to have media integration enabled.</span>
        </b-form-group>

        <b-form-group
            v-if="libraries !== null && libraryOptions"
            label="Libraries"
            description="Allowed libraries that can be choosen from"
            label-for="libs"
            :label-cols="2"
            :horizontal="false">
            <v-select v-model="constraints.custom_data.file.libraries" label="name" :options="libraries" multiple :reduce="lib => lib.uuid" />
        </b-form-group>

        <b-form-group
            v-if="libraryOptions"
            label="Extensions"
            description="Filter files from library by extension"
            label-for="libs"
            :label-cols="2"
            :horizontal="false">
            <v-select v-model="constraints.custom_data.file.extensions"  multiple taggable />
        </b-form-group>

        <b-form-group
            description="User choose file from device and it will be uploaded to library"
            label="Choose from device"
            label-for="choose_from_device"
            :label-cols="4"
            :horizontal="true">
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.file.chooseFromDevice"  @change="(e) => handleChange('deviceOptions', e)" v-if="mediaIntegrationActive"/>
                <span v-else>To use this funcionality you need to have media integration enabled.</span>
        </b-form-group>

        <b-form-group
            v-if="libraries !== null && deviceOptions"
            label="Default library"
            description="Default library where files will be uploaded from this field"
            label-for="defaultLibrary"
            :label-cols="2"
            :horizontal="false">
            <v-select v-model="constraints.custom_data.file.defaultLibrary" label="name" :options="libraries" :reduce="lib => lib.uuid" />
        </b-form-group>

        <b-form-group
            v-if="mediaIntegrationActive"
            description="Allow multiple files selection"
            label="Multiple files"
            label-for="multiple_files"
            :label-cols="4"
            :horizontal="true">
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.file.multiple" @change="(e) => handleChange('multipleOptions', e)"/>
        </b-form-group>
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import InputField from '@/components/form/Input'
import SelectField from "@/components/form/Select"
import VSelect from 'vue-select'

export default {
    components: {
        InputField,
        SelectField,
        cSwitch,
        VSelect
    },
    props: {
        value: {
            type: Object
        }
    },
    data: function() {
        return {
            errors: [],
            libraries: null,
            libraryOptions: false,
            deviceOptions: false,
            multipleOptions: false
        }
    },
    computed: {
        constraints: {
            get() {
                let base = this.value

                base.custom_data.file = base.custom_data.file || {}

                return base;
            },

            set(val) {
                this.save()
            }
            
        },

        mediaIntegrationActive() {
            return this.$store.getters.isIntegrationActive('protokol-media')
        }
    },
    methods: {
        save() {
            this.$emit('input', this.constraints)
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        handleChange(key, val) {
            this[key] = val
        }
    },

    mounted() {
        this.$store.dispatch('fetchLibraries').then(libs => {
            this.libraries = libs
        })
    }
    
}
</script>